import { Component, OnDestroy, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CookieService } from 'src/app/services/cookie/cookie.service';
import { StaffLoginService } from 'src/app/services/staff-login/staff-login.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import 'moment-timezone';
import * as countriesAndTimezones from 'countries-and-timezones';

declare let gtag: Function;
declare let grecaptcha: any;
declare global {
  interface Window { dataLayer: any[]; }
}

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit, OnDestroy {
  @ViewChild('passwordRef') user_password: ElementRef;

  current_url: string;
  sales_enquiry_id: string = '';
  form_cta_type: string = '';
  verificationScreenIndex: number = 0;

  cnfrm_pass_error_matcher = new ConfirmPasswordErrorStateMatcher();
  signup_form: FormGroup;
  filtered_country_options: ReplaySubject<any> = new ReplaySubject<any>(1);
  country_search_ctrl: FormControl = new FormControl('');
  is_pass_type_password = true;
  is_confirm_pass_type_password = true;
  is_loading: boolean = false;
  personal_email_domain: string;
  selectedIndex: any = 0;
  potential_total_users = [
    {
      displayValue: '1-50',
      value: '0-50'
    },
    {
      displayValue: '51-100',
      value: '50-100'
    },
    {
      displayValue: '101-200',
      value: '100-200'
    },
    {
      displayValue: '201-500',
      value: '200-500'
    },
    {
      displayValue: '501-1000',
      value: '500-1000'
    },
    {
      displayValue: '1001-5000',
      value: '1000-5000'
    },
    {
      displayValue: 'Above 5000',
      value: 'Above 5000'
    },
  ];

  sessionData: any;
  ip_address: any = '135.148.233.69';

  countries: any;
  invalid_error_msg: any;
  private onDestroy = new Subject<void>();
  is_validation_pending: boolean;
  is_updating_client: boolean = false;

  login_response: any;
  signup_response: any;
  // {
  //   data: {
  //     mobile: '1243242554',
  //     office_email: 'sdhgfas@truein.com',
  //     country_name: 'India',
  //     country_code: '7',
  //     sms_verified: '0',
  //     email_verified: '0',
  //     region: 'India',
  //     client_site_id: '123'
  //   }
  // };
  timezone = moment.tz.guess();
  timezone_hrs = moment().tz(this.timezone).format('Z');
  auth_modules: any[] = [];
  client_details: any[] = [];
  params: any;
  location_details: any = {
    timezone: 'America/New_York',
    timezone_hrs: moment().tz('America/New_York').format('Z'),
    country_name: 'United States',
    country_code: '1'
  };

  is_signup_loading: boolean = false;
  is_websignup: boolean = false;

  is_fromSignup: boolean = false;
  is_session_created: boolean = false;
  submitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
    private cookieService: CookieService,
    private staffLoginService: StaffLoginService,
    private route: ActivatedRoute
  ) {
    this.signup_form = this.formBuilder.group({
      company_name: ['', [Validators.required, this.checkNoSpecialChars, this.checkNoUrlsOrScripts]],
      first_name: ['', [Validators.required, this.checkNoSpecialChars, this.checkNoUrlsOrScripts]],
      last_name: ['', [Validators.required, this.checkNoSpecialChars, this.checkNoUrlsOrScripts]],
      office_email: ['', [Validators.required, Validators.email]],
      country_code: ['', Validators.required],
      mobile_number: ['', Validators.required],
      password: ['', [this.gatedSignupPasswordValidator()]],
      company_size: ['', Validators.required],
      // confirm_password: ['', Validators.required],
    });
    this.sessionData = this.route.snapshot.data.sessionData;
    if (this.sessionData && this.sessionData?.data) {
      if ((this.sessionData?.data?.email_verified == '0' && this.sessionData?.data?.office_email != '') || (this.sessionData?.data?.sms_verified == '0' && this.sessionData?.data?.mobile != '' && this.sessionData?.data?.country_code == '91') || this.sessionData?.data?.is_referral_pending == '1') {
        const referral_data = this.sessionData?.data?.referral_data ? JSON.parse(this.sessionData?.data?.referral_data) : '';

        this.signup_response = {
          data: {
            mobile: this.sessionData?.data?.mobile,
            office_email: this.sessionData?.data?.office_email,
            country_name: this.sessionData?.data?.country_name,
            country_code: this.sessionData?.data?.country_code,
            sms_verified: this.sessionData?.data?.sms_verified,
            email_verified: this.sessionData?.data?.email_verified,
            client_region: this.sessionData?.data?.client_region ?? '',
            client_site_id: this.sessionData?.data?.client_site_id,
            client_id: this.sessionData?.data?.client_id,
            user_id: this.sessionData?.data?.user_id,
            sales_enquiry_id: this.sessionData?.data?.sales_enquiry_id,
            is_referral_pending: this.sessionData?.data?.is_referral_pending,
            referral_data: this.sessionData?.data?.referral_data,
            size: referral_data?.size
          }
        };
        this.is_fromSignup = true;
        if (this.sessionData?.data?.email_verified == '0') {
          this.verificationScreenIndex = 0;
          this.selectedIndex = 1;
        } else if (this.sessionData?.data?.sms_verified == '0' && this.sessionData?.data?.mobile != '' && this.sessionData?.data?.country_code == '91') {
          this.verificationScreenIndex = 1;
          this.selectedIndex = 1;
        } else {
          this.selectedIndex = 2;
        }
      }
    };

    router.events.pipe(takeUntil(this.onDestroy)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.current_url = event.urlAfterRedirects;
        if (this.current_url.includes('/setup')) {
          this.selectedIndex = 2;
        };
      };
    });
  }

  ngOnInit() {
    if (this.sessionData?.data?.is_referral_pending == '1' && this.sessionData?.data?.email_verified == '1' && this.sessionData?.data?.sms_verified == '1') {
      this.router.navigate(['setup'], { state: { login_response: this.signup_response }, queryParams: { call_trial: '0' }, queryParamsHandling: 'merge' });
    };
    this.route.queryParams.subscribe(params => {
      this.params = params;
    });
    this.staffLoginService.signUpView.pipe(takeUntil(this.onDestroy)).subscribe(value => {
      this.is_websignup = value == 'web_signup' && (this.current_url.includes('/signup') || this.current_url.includes('/setup'));
    });
    this.staffLoginService.isTrialSignupLoading.pipe(takeUntil(this.onDestroy)).subscribe(value => {
      this.is_signup_loading = value;
    });
    // this.getIpAddress();
    this.country_search_ctrl.valueChanges.pipe(takeUntil(this.onDestroy)).subscribe((searchText) => {
      this.filterWithinDropdownItems(searchText, 'countries', 'filtered_country_options');
    });

    // Clear password field-level error on the next edit after a failed submit.
    this.signup_form.get('password').valueChanges.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      if (this.submitted) {
        this.submitted = false;
        this.signup_form.get('password').updateValueAndValidity({ emitEvent: false });
      }
    });

    this.signup_form.get('office_email').valueChanges.pipe(takeUntil(this.onDestroy)).subscribe((value) => {
      const email_domain = value.substring(value.lastIndexOf("@") +1)
      this.personal_email_domain = email_domain;
      if (this.signup_form.get('office_email').hasError('personal_email')) {
        let errors = this.signup_form.get('office_email').errors;
          delete errors['personal_email'];
          this.signup_form.get('office_email').setErrors(errors);
        }
    });

    this.signup_form.get('country_code').valueChanges.pipe(takeUntil(this.onDestroy)).subscribe((value: any) => {
      // const timezones: any = countriesAndTimezones.getTimezonesForCountry(value?.alpha2_iso)?.[0];

      // this.location_details = {
      //   timezone: timezones?.name,
      //   timezone_hrs: moment().tz(timezones?.name).format('Z'),
      //   country_name: value?.country_name,
      //   country_code: value?.country_code
      // };
      this.location_details.country_name = value?.country_name;
      this.location_details.country_code = value?.country_code;

      if (value.country_code == '91') {
        this.signup_form.get('mobile_number').setValidators([Validators.required, Validators.pattern(/^\d{10}$/)]);
      } else {
        this.signup_form.get('mobile_number').setValidators([Validators.required]);
      };
     this.signup_form.get('mobile_number').updateValueAndValidity();

    });
    const locationCookieObj = this.cookieService.getCookie('location_details');

    // Auto filing the form from the pricing page of the website (Free Self Signup Trial)
    if (this.params?.redirect) {
      const base64Params = this.params?.redirect;
      if (base64Params) {
        const base64ParamsDecoded = atob(base64Params);
        if (!this.isURIMalformed(base64ParamsDecoded)) {
          const decodedURL = decodeURIComponent(base64ParamsDecoded);
          const queryParams = new URLSearchParams(decodedURL);
          const queryParamsObject: any = {};

          queryParams.forEach((value, key) => {
            queryParamsObject[key] = value;
          });

          if (queryParamsObject) {
            this.signup_form.patchValue({
              company_name: queryParamsObject?.company,
              first_name: queryParamsObject?.first_name,
              last_name: queryParamsObject?.last_name,
              office_email: queryParamsObject?.email,
              country_code: queryParamsObject?.country,
              mobile_number: queryParamsObject?.mobile,
              company_size: queryParamsObject?.size,
            }, { emitEvent: false });

            this.sales_enquiry_id = queryParamsObject.sales_enquiry_id ? queryParamsObject.sales_enquiry_id : '';
            this.form_cta_type = queryParamsObject.cta_type ? queryParamsObject.cta_type.includes('standard') ? 'self-signup-standard-pricing' : queryParamsObject.cta_type.includes('premium') ? 'self-signup-premium-pricing' : '' : '';
            // const timezones: any = countriesAndTimezones.getTimezonesForCountry(queryParamsObject?.country_alpha2_code)[0];

            if (queryParamsObject?.country_name && queryParamsObject?.country_code && queryParamsObject?.via) {
              // this.location_details = {
              //   timezone: timezones?.name,
              //   timezone_hrs: moment().tz(timezones?.name).format('Z'),
              //   country_name: queryParamsObject?.country_name,
              //   country_code: queryParamsObject?.country_code
              // };
              this.location_details.country_name = queryParamsObject?.country_name;
              this.location_details.country_code = queryParamsObject?.country_code;
              this.getIpAddress('timezone');
            } else if (locationCookieObj) {
              this.location_details = JSON.parse(decodeURIComponent(locationCookieObj));
              this.getCountryCode();
            } else {
              this.getIpAddress('country');
            };
            setTimeout(() => {
              this.signup_form.get('password').markAsTouched({ onlySelf: true });
              this.user_password.nativeElement.focus();
            }, 0);
          };
        } else if (locationCookieObj) {
          this.location_details = JSON.parse(decodeURIComponent(locationCookieObj));
          this.getCountryCode();
        } else {
          this.getIpAddress('country');
        };
      };
    } else if (this.params?.websignup) { //auto filling the form and calling free trial signup
      this.staffLoginService.setSignupView('web_signup');
      if (this.params?.call_trial == '1') {
        this.staffLoginService.setLoadingValue(true);
      };

      const base64Params = this.params?.websignup;
      if (base64Params) {
        const base64ParamsDecoded = atob(base64Params);
        if (!this.isURIMalformed(base64ParamsDecoded)) {
          const decodedURL = decodeURIComponent(base64ParamsDecoded);
          const queryParams = new URLSearchParams(decodedURL);
          const queryParamsObject: any = {};

          queryParams.forEach((value, key) => {
            queryParamsObject[key] = value;
          });

          if (queryParamsObject) {
            this.signup_form.patchValue({
              company_name: queryParamsObject?.company,
              first_name: queryParamsObject?.first_name,
              last_name: queryParamsObject?.last_name,
              office_email: queryParamsObject?.email,
              country_code: queryParamsObject?.country_code,
              mobile_number: queryParamsObject?.mobile,
              company_size: queryParamsObject?.size,
              password: queryParamsObject?.password,
            }, { emitEvent: false });

            const utm_data = JSON.parse(queryParamsObject?.utm);

            if (utm_data?.utm_source) {
              this.cookieService.setCookie('utm_source', utm_data?.utm_source, 1);
            }
            if (utm_data?.utm_medium) {
              this.cookieService.setCookie('utm_medium', utm_data?.utm_medium, 1);
            }
            if (utm_data?.utm_campaign) {
              this.cookieService.setCookie('utm_campaign', utm_data?.utm_campaign, 1);
            }

            this.sales_enquiry_id = queryParamsObject.sales_enquiry_id ? queryParamsObject.sales_enquiry_id : '';
            this.form_cta_type = queryParamsObject.cta_type ? queryParamsObject.cta_type : '';

            if (queryParamsObject?.country_name && queryParamsObject?.country_code && queryParamsObject?.via) {
              this.location_details.country_name = queryParamsObject?.country_name;
              this.location_details.country_code = queryParamsObject?.country_code;
              this.getIpAddress('timezone');
            } else if (locationCookieObj) {
              this.location_details = JSON.parse(decodeURIComponent(locationCookieObj));
            } else {
              this.getIpAddress('country');
            };
          };
        } else if (locationCookieObj) {
          this.location_details = JSON.parse(decodeURIComponent(locationCookieObj));
        } else {
          this.getIpAddress('country');
        };
      };
    } else if (locationCookieObj) {
      this.location_details = JSON.parse(decodeURIComponent(locationCookieObj));
      this.getCountryCode();
    } else {
      this.getIpAddress('country');
    };
  }

  seededRandom(seed: number): number {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }

  getWeeklyTrialCount(): number {
    const now = moment();
  
    const week = now.isoWeek();
    const year = now.isoWeekYear();
  
    const seed = year * 100 + week;
  
    const random = this.seededRandom(seed);
  
    return Math.floor(22 + random * (40 - 22));
  }

  isURIMalformed(uri: string): boolean {
    try {
      decodeURIComponent(uri);
      return false; // The URI is valid
    } catch (e) {
      if (e instanceof URIError) {
        return true; // The URI is malformed
      } else {
        throw e; // Some other unexpected error occurred
      };
    };
  }

  redirectToLogin() {
    // window.open(`${environment.base_url}/account/login`, '_self');
    this.router.navigate(['login']);
  }

  checkUppercase(control) {
    return control.value && control.value.match(/[A-Z]/) ? null : { uppercase: true }
  }

  checkNumber(control) {
    return control.value && control.value.match(/[0-9]/) ? null : { number: true }
  }

  private gatedSignupPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.submitted) return null;
      const value: string = control.value ?? '';
      if (!value) return { required: true };
      const errors: ValidationErrors = {};
      if (value.length < 8) errors['minlength'] = { requiredLength: 8, actualLength: value.length };
      if (value.length > 20) errors['maxlength'] = { requiredLength: 20, actualLength: value.length };
      if (!value.match(/[A-Z]/)) errors['uppercase'] = true;
      if (!value.match(/[0-9]/)) errors['number'] = true;
      return Object.keys(errors).length === 0 ? null : errors;
    };
  }

  // Custom validators for preventing special characters, URLs, and scripts
  checkNoSpecialChars(control) {
    if (!control.value) return null;
    const isCompanyName = control.parent && Object.keys(control.parent.controls).find(key => control.parent.controls[key] === control) === 'company_name';
    // Company name also allows '#'; other fields allow only letters, numbers, spaces, hyphens, apostrophes, and periods
    const validPattern = isCompanyName ? /^[a-zA-Z0-9\s\-'\.#]+$/ : /^[a-zA-Z0-9\s\-'\.]+$/;
    return validPattern.test(control.value) ? null : { specialChars: true };
  }

  checkNoUrlsOrScripts(control) {
    if (!control.value) return null;
    // Check for URLs (http, https, www, .com, .org, etc.)
    const urlPattern = /(https?:\/\/|www\.|\.com|\.org|\.net|\.io|\.co|\.in|\.uk|\.de|\.fr|\.es|\.it|\.ca|\.au|\.jp|\.cn|\.br|\.ru|\.kr|\.mx|\.nl|\.se|\.ch|\.no|\.dk|\.fi|\.pl|\.pt|\.at|\.be|\.ie|\.nz|\.sg|\.my|\.th|\.vn|\.ph|\.id|\.tr|\.ae|\.sa|\.eg|\.za|\.ng|\.ke|\.gh|\.ug|\.tz|\.zm|\.mw|\.bw|\.na|\.sz|\.ls|\.ss|\.et|\.so|\.dj|\.km|\.mg|\.mu|\.sc|\.re|\.yt|\.tf|\.pf|\.nc|\.vu|\.fj|\.pg|\.sb|\.to|\.ws|\.ki|\.nr|\.tv|\.fm|\.mh|\.pw|\.ck|\.nu|\.tk|\.wf|\.as|\.gu|\.mp|\.pr|\.vi|\.us|\.um|\.bl|\.mf|\.gp|\.mq|\.lc|\.vc|\.bb|\.gd|\.ag|\.dm|\.kn|\.ai|\.ms|\.tc|\.vg|\.ky|\.bm|\.fk|\.gi|\.sh|\.ac|\.ta|\.io|\.cx|\.cc|\.nf|\.aq|\.hm|\.gs|\.bv|\.sj|\.pm|\.tf|\.yt|\.wf|\.pf|\.nc|\.vu|\.fj|\.pg|\.sb|\.to|\.ws|\.ki|\.nr|\.tv|\.fm|\.mh|\.pw|\.ck|\.nu|\.tk|\.wf|\.as|\.gu|\.mp|\.pr|\.vi|\.us|\.um|\.bl|\.mf|\.gp|\.mq|\.lc|\.vc|\.bb|\.gd|\.ag|\.dm|\.kn|\.ai|\.ms|\.tc|\.vg|\.ky|\.bm|\.fk|\.gi|\.sh|\.ac|\.ta|\.io|\.cx|\.cc|\.nf|\.aq|\.hm|\.gs|\.bv|\.sj|\.pm)/i;

    // Check for script tags and common script patterns
    const scriptPattern = /<script|javascript:|vbscript:|onload=|onerror=|onclick=|onmouseover=|onfocus=|onblur=|onchange=|onsubmit=|onreset=|onselect=|onunload=|onabort=|onbeforeunload=|onerror=|onhashchange=|onmessage=|onoffline=|ononline=|onpagehide=|onpageshow=|onpopstate=|onresize=|onstorage=|oncontextmenu=|oninput=|oninvalid=|onsearch=|onkeydown=|onkeypress=|onkeyup=|onmousedown=|onmouseenter=|onmouseleave=|onmousemove=|onmouseout=|onmouseup=|onwheel=|oncopy=|oncut=|onpaste=|onabort=|onbeforecopy=|onbeforecut=|onbeforepaste=|onblur=|onchange=|onclick=|oncontextmenu=|oncopy=|oncut=|ondblclick=|onerror=|onfocus=|onfocusin=|onfocusout=|onhashchange=|oninput=|oninvalid=|onkeydown=|onkeypress=|onkeyup=|onload=|onmessage=|onmousedown=|onmouseenter=|onmouseleave=|onmousemove=|onmouseout=|onmouseover=|onmouseup=|onmousewheel=|onoffline=|ononline=|onpagehide=|onpageshow=|onpaste=|onpopstate=|onresize=|onsearch=|onselect=|onstorage=|onunload=|onwheel/i;

    if (urlPattern.test(control.value) || scriptPattern.test(control.value)) {
      return { urlsOrScripts: true };
    }
    return null;
  }

  getFieldErrorMsg(pass_field: string) {
    let error_msg: string = 'Password must contain at least ';
    if (this.signup_form.controls[pass_field].errors?.maxlength) {
      return 'Password should be less than 20 characters';
    };
    if(this.signup_form.controls[pass_field].errors?.minlength) {
      error_msg += '8 characters';
    };
    if(this.signup_form.controls[pass_field].errors?.uppercase) {
      error_msg += this.signup_form.controls[pass_field].errors?.minlength ? ', one uppercase letter' : 'one uppercase letter';
    };
    if(this.signup_form.controls[pass_field].errors?.number) {
      error_msg += this.signup_form.controls[pass_field].errors?.minlength || this.signup_form.controls[pass_field].errors?.uppercase ? ', one number' : 'one number';
    };
    return error_msg.replace(/,(?=[^,]*$)/, ", and");
  }

  checkEmailMobileExist(type) {
    let credentials;
    if (type == 'mobile' && !this.signup_form.get('mobile_number')?.hasError('required')) {
      let errors = this.signup_form.get('mobile_number').errors;
      if (errors?.mobile_already_exist) {
        delete errors['mobile_already_exist'];
        this.signup_form.get('mobile_number').setErrors(errors);
      }
      credentials = {
        mobile_number: this.signup_form.get('mobile_number').value,
        country_code: this.signup_form.get('country_code').value?.country_code,
      }
    } else if (type == 'email' && !(this.signup_form.get('office_email')?.hasError('required') || this.signup_form.get('office_email')?.hasError('email'))) {
      let errors = this.signup_form.get('office_email').errors;
      if (errors?.email_already_exist) {
        delete errors['email_already_exist'];
        this.signup_form.get('office_email').setErrors(errors);
      }
      credentials = {
        office_email: this.signup_form.get('office_email').value,
      }
    } else {
      return;
    };
    if (this.is_updating_client) {
      credentials.user_id = this.signup_response?.data?.user_id;
    };
    this.is_validation_pending = true;
    this.authService.checkEmailMobileExist(credentials).subscribe((response: any) => {
      if (type == 'mobile' && response?.code == '1') {
        this.signup_form.get('mobile_number').setErrors({ ...this.signup_form.get('mobile_number').errors, mobile_already_exist: true });
      } else if (type == 'email' && response?.code == '2') {
        this.signup_form.get('office_email').setErrors({ ...this.signup_form.get('office_email').errors, email_already_exist: true })
      }
      this.is_validation_pending = false;
    }, error => {
      console.log(error);
      this.is_validation_pending = false;
    })
  }

  updateClient() {
    this.submitted = true;
    this.signup_form.get('password').updateValueAndValidity({ emitEvent: false });
    this.signup_form.markAllAsTouched();
    if (this.signup_form.valid) {
      const referral_data = {
        industry: '',
        reference: '',
        size: this.signup_form.get('company_size').value
      };

      const credentials: any = {
        user_id: this.signup_response?.data?.user_id,
        client_id: this.signup_response?.data?.client_id,
        client_site_id: this.signup_response?.data?.client_site_id,
        first_name: this.signup_form.get('first_name').value,
        last_name: this.signup_form.get('last_name').value,
        admin_name: this.signup_form.get('first_name').value + ' ' + this.signup_form.get('last_name').value,
        primary_mobile: this.signup_form.get('mobile_number').value,
        primary_email: this.signup_form.get('office_email').value,
        company_name: this.signup_form.get('company_name').value,
        size: this.signup_form.get('company_size').value,
        password: this.signup_form.get('password').value,
        country_code: this.signup_form.get('country_code').value.country_code,
        country_iso: this.signup_form.get('country_code').value?.alpha2_iso,
        timezone: this.location_details.timezone,
        timezone_hrs: this.location_details.timezone_hrs,
        sales_enquiry_id: this.signup_response?.data?.sales_enquiry_id,
        referral_data: JSON.stringify(referral_data),
        via: 'web_dashb',
        via_page: 'self_signup',
      };

      if (this.form_cta_type) {
        credentials.cta_type = this.form_cta_type;
      };
      this.is_loading = true;

      this.authService.updateClient(credentials).pipe(takeUntil(this.onDestroy)).subscribe((res: any) => {
        if (res.code == '1') {
          this.signup_response = {
            data: {
              mobile: this.signup_form.get('mobile_number').value,
              office_email: this.signup_form.get('office_email').value,
              country_name: this.location_details?.country_name,
              country_code: this.location_details?.country_code,
              sms_verified: ['india'].includes(res?.data?.fnClientRegion?.toString().toLowerCase()) ? '0' : '1',
              email_verified: res?.data?.email_verified ? res?.data?.email_verified : '0',
              client_region: res?.data?.fnClientRegion,
              client_id: res?.data?.client_id,
              user_id: res?.data?.primary_user_id ? res?.data?.primary_user_id : this.signup_response?.data?.user_id,
              sales_enquiry_id: res?.data?.sales_enquiry_id,
              is_referral_pending: '1',
              size: this.signup_form.get('company_size').value,
            }
          }
          if (this.signup_response?.data?.email_verified == '1' && !['india'].includes(res?.data?.fnClientRegion?.toString().toLowerCase())) {
            this.loginToDashboard();
          } else {
            this.verificationScreenIndex = 0;
            this.selectedIndex = 1;
          };
        } else {
          this.is_loading = false;
          if (res.message == 'Please enter valid company email.') {
            this.signup_form.get('office_email').setErrors({ ...this.signup_form.get('office_email').errors, personal_email: true })
          }
          else {
            this.snackBar.open(res.message);
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event' : 'error',
            'errorType' : 'registration error',
            'errorMessage' : res.message
          });
        };
      }, (err) => {
        this.is_loading = false;
        console.log(err);
      });
    };
  }

  private loadRecaptcha(): Promise<void> {
    if (typeof grecaptcha !== 'undefined') {
      return Promise.resolve();
    }
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${environment.recaptcha_site_key}`;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('recaptcha load failed'));
      document.head.appendChild(script);
    });
  }

  // v3 tokens expire ~2 min, so fetch a fresh one at submit time
  private getCaptchaToken(): Promise<string> {
    return this.loadRecaptcha().then(() => new Promise<string>((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(environment.recaptcha_site_key, { action: 'signup' })
          .then((token: string) => resolve(token))
          .catch((err: any) => reject(err));
      });
    }));
  }

  freeTrialSignUp() {
    this.is_updating_client = false;
    this.submitted = true;
    this.signup_form.get('password').updateValueAndValidity({ emitEvent: false });
    this.signup_form.markAllAsTouched();
    if (this.signup_form.valid) {
      const referral_data = {
        industry: '',
        reference: '',
        size: this.signup_form.get('company_size').value
      };

      let credentials = {
        ...this.signup_form.value,
        via: 'website',
        timezone: this.location_details.timezone,
        timezone_hrs: this.location_details.timezone_hrs,
        admin_name: this.signup_form.get('first_name').value + ' ' + this.signup_form.get('last_name').value,
        country_code: this.signup_form.get('country_code').value?.country_code,
        country_name: this.location_details.country_name,
        country_iso: this.signup_form.get('country_code').value?.alpha2_iso,
        // country_short_name: this.countryDetails?.id,
        // country_code: this.countryDetails?.calling_code,
        personal_email: this.cookieService.getCookie('personal_email') ? this.cookieService.getCookie('personal_email') : '0',
        utm_source: this.cookieService.getCookie('utm_source') ? this.cookieService.getCookie('utm_source') : '',
        utm_medium: this.cookieService.getCookie('utm_medium') ? this.cookieService.getCookie('utm_medium') : '',
        utm_campaign: this.cookieService.getCookie('utm_campaign') ? this.cookieService.getCookie('utm_campaign') : '',
        referral_data: JSON.stringify(referral_data)
      };
      if (this.sales_enquiry_id) {
        credentials.sales_enquiry_id = this.sales_enquiry_id;
      };
      if (this.form_cta_type) {
        credentials.cta_type = this.form_cta_type;
      };
      this.is_loading = true;
      this.staffLoginService.setLoadingValue(this.is_loading);

      this.getCaptchaToken().then((captcha_token: string) => {
        credentials.captcha_token = captcha_token;
        this.authService.freeTrialSignUp(credentials).pipe(takeUntil(this.onDestroy)).subscribe(
        (res: any) => {
          if (res.code == '1') {
            this.signup_response = {
              data: {
                mobile: this.signup_form.get('mobile_number').value,
                office_email: this.signup_form.get('office_email').value,
                country_name: this.location_details?.country_name,
                country_code: this.location_details?.country_code,
                sms_verified: ['india'].includes(res?.data?.fnClientRegion?.toString().toLowerCase()) ? '0' : '1',
                email_verified: '0',
                client_region: res?.data?.fnClientRegion,
                client_id: res?.data?.client_id,
                user_id: res?.data?.primary_user_id,
                sales_enquiry_id: res?.data?.sales_enquiry_id,
                is_referral_pending: '1',
                size: this.signup_form.get('company_size').value
              }
            };
            this.selectedIndex = 1;
            this.staffLoginService.setLoadingValue(false);
          } else {
            this.is_loading = false;
            this.staffLoginService.setLoadingValue(this.is_loading);
            this.staffLoginService.setSignupView('signup');

            if (res.message == 'Please enter valid company email.') {
              this.signup_form.get('office_email').setErrors({ ...this.signup_form.get('office_email').errors, personal_email: true })
            }
            else {
              this.snackBar.open(res.message);
            }
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event' : 'error',
              'errorType' : 'registration error',
              'errorMessage' : res.message
            });
          }
        },
        err => {
          this.is_loading = false;
          this.staffLoginService.setLoadingValue(this.is_loading);
          console.log(err);
        },
      );
      }).catch(() => {
        this.is_loading = false;
        this.staffLoginService.setLoadingValue(this.is_loading);
        this.snackBar.open('Verification failed, please try again.');
      });
    };
  }

  backToSignupPage() {
    this.is_loading = false;
    this.is_updating_client = true;
    this.selectedIndex = 0;
  }

  getIpAddress(get_info) {

    this.staffLoginService.getIpAddress().pipe(takeUntil(this.onDestroy)).subscribe((res: any) => {
      if (res) {
        this.ip_address = res?.ip ?? '135.148.233.69';
      };
    }, (err) => {
      console.log('err', err);
    }, () => {
      if (get_info == 'timezone') {
        this.getTimeZone();
      } else {
        this.getGeolocationDetails();
      };
    });
  }

  getGeolocationDetails() {

    const credentials = {
      ip_address: this.ip_address,
      via: 'signup'
    };

    this.staffLoginService.geoLocationDetails(credentials).pipe(takeUntil(this.onDestroy)).subscribe((res: any) => {
      if (res && res?.country_name) {
        this.location_details = {
          timezone: res?.time_zone?.id,
          timezone_hrs: moment().tz(res?.time_zone?.id).format('Z'),
          country_name: res?.country_name,
          country_code: res?.location?.calling_code
        };
      };
    }, (err) => {
      console.log('err', err);
    }, () => {
      this.getCountryCode();
      this.saveLocationDetails(this.location_details);
    });
  }

  getTimeZone() {

    const credentials = {
      ip_address: this.ip_address,
      via: 'signup'
    };

    this.staffLoginService.geoLocationDetails(credentials).pipe(takeUntil(this.onDestroy)).subscribe((res: any) => {
      if (res && res?.country_name) {
        this.location_details.timezone = res?.time_zone?.id;
        this.location_details.timezone_hrs = moment().tz(res?.time_zone?.id).format('Z');
      };
    }, (err) => {
      console.log('err', err);
    }, () => {
      this.getCountryCode();
      this.saveLocationDetails(this.location_details);
    });
  }

  getScreenIndex(event) {
    this.verificationScreenIndex = event;
  }

  saveLocationDetails(location_details) {
    const expirationDate = new Date();
    expirationDate.setMinutes(expirationDate.getMinutes() + 10);

    document.cookie = `location_details=${encodeURIComponent(JSON.stringify(location_details))}; expires=${expirationDate.toUTCString()}; path=/`;
  }

  openDashboardWindow(signup_response) {
    window.open(`${environment.base_url}/staff`, '_self');
  }

  loginToDashboardFromSignup(signup_response) {

    if (this.signup_response?.data?.is_referral_pending == '1') {
      this.router.navigate(['setup'], { state: { login_response: this.signup_response }, queryParams: { call_trial: '0' }, queryParamsHandling: 'merge' });
    } else {
      this.openDashboardWindow(signup_response);
    };
  }

  loginToDashboard() {
    const _credentials = {
      office_email: this.signup_form.get('office_email').value.trim(),
      password: this.signup_form.get('password').value,
      via: 'web_dashb'
    };
    this.is_session_created = true;
    this.staffLoginService.parentAuthenticate(_credentials).pipe(takeUntil(this.onDestroy)).subscribe(parent_res => {
      this.login_response = parent_res;
      }, error => {
        console.log('error', error);
      }, () => {
        if (this.login_response.code == '1') {
          let _credentials = '&via=web_dashb';
          if (environment.login_type == 'local_login') {
            _credentials = 'office_email=' + this.signup_form.get('office_email').value +
              '&password=' + this.signup_form.get('password').value + '&via=web_dashb';
          };
          this.authService.empLogin(_credentials).pipe(takeUntil(this.onDestroy)).subscribe(response => {
              this.login_response = response;
              // this.router.navigate([`verify-account`], {
              //   queryParams: {
              //       mobile_number: credentials.mobile_number,
              //       country_code: credentials.country_code,
              //       office_email: credentials.office_email
              //     }
            }, error => {
              console.log(error);
            }, () => {
              if(this.login_response.code == '1' || this.login_response.code == '2') {
                this.router.navigate(['setup'], { state: { login_response: this.signup_response }, queryParams: { call_trial: '0' }, queryParamsHandling: 'merge' });

                // this.client_details = this.login_response?.data.client_details;
                // this.auth_modules = this.login_response?.data?.authorised_modules ? this.login_response?.data.authorised_modules.replace(' ','').split(',') : [];

                // if(this.login_response?.data.authorised_modules.match(this.login_response?.data.last_module)) {
                //   window.open(`${environment.base_url}/` + this.login_response?.data.last_module, '_self');
                // } else {
                //   window.open(`${environment.base_url}/` + this.auth_modules[0], '_self');
                // };
                this.gtag_report_conversion(window.location.href);
              } else {
                // this.error_msg = `Error! Please Contact <a href="mailto:support@truein.com">support@truein.com</a>`;
                // this.is_logging = false;
              };
              // this.router.navigate([`login`]
              // ).then(() => {
              // });
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event' : 'registration',
              'authenticationMethod' : 'email',
              'userId' : this.signup_response?.data?.sales_enquiry_id
            });
        } else {
          this.is_session_created = false;
        };
      });
  }

  filterWithinDropdownItems(searchText, arrayToSearch, filterArrReplaySub) {
    if (!arrayToSearch || arrayToSearch.length == 0) {
      return;
    }
    if (!searchText) {
      this[filterArrReplaySub].next(this[arrayToSearch]);
      return;
    } else {
      searchText = searchText.toLowerCase();
    }

    if (arrayToSearch == 'countries') {
      this[filterArrReplaySub].next(
        this[arrayToSearch].filter((item: any) => {
          return (item.country_name + '(' + item.native_name + ') +' + item.country_code).toString().toLowerCase().indexOf(searchText) > -1;
        })
      );
    }
  }

  getFlagUrl(country) {
    return (`assets/flags/${country?.alpha2_iso}.svg`)?.toLowerCase();
  }

  getCountryCode() {
    this.staffLoginService.getCountryMasterList().pipe(takeUntil(this.onDestroy)).subscribe((res: any) => {
      if (res && res.code == '1') {
        this.countries = res.data;
        this.filtered_country_options.next(res.data);
      };
      this.countries.forEach((country: any) => {
        if (this.location_details?.country_code) {
          if (country.country_code == this.location_details?.country_code) {
            this.signup_form.patchValue({ country_code: country }, { emitEvent: false });
            this.staffLoginService.setUserRegion(country?.alpha2_iso);
            if (this.signup_form.get('country_code').value.country_code == '91') {
              this.signup_form.get('mobile_number').setValidators([Validators.required, Validators.pattern(/^\d{10}$/)]);
            } else {
              this.signup_form.get('mobile_number').setValidators([Validators.required]);
            };
            this.signup_form.get('mobile_number').updateValueAndValidity();
          };
        } else {
          if (country.country_code == '1') {
            this.signup_form.patchValue({ country_code: country }, { emitEvent: false });
            this.staffLoginService.setUserRegion(country?.alpha2_iso);
          };
        };
      });
    }, err => {
      console.log('err', err);
    }, () => {
      //if coming from landing page 'stop leakage trial'
      if (this.params?.call_trial == '1' && this.params?.websignup) {
        this.freeTrialSignUp();
      };
    });
  }

  // // Event snippet for Self Sign-up conversion page In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button.
  gtag_report_conversion(url) {
    var callback = (value)=> {
      console.log(value, true);
      if (typeof (url) != 'undefined') {
        window.location = url;
      }
    };
    gtag('event', 'conversion', { 'send_to': 'AW-777362244/tDhkCMunvYIDEMS21vIC', 'event_callback': callback });
    return false;
  }

  passwordValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.get('password');
    const confirm_password = control.get('confirm_password');

    if (password.pristine || confirm_password.pristine) {
      return null;
    }

    return password && confirm_password && password.value != confirm_password.value ?
      { 'misMatch': true } : null;
  }

  countryCodeComparator(o1: any, o2: any) {
    return (o1.alpha2_iso == o2.alpha2_iso) || o1 == o2;
  }

  getCountryOptLength(country) {
    const text = country?.country_name + ' ('+ country?.native_name +') +' + country?.country_code;
    return text?.length < 33;
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}

export class ConfirmPasswordErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && (control.parent?.hasError('misMatch') || control.invalid) && control.touched);
  }
}

